/**
 * Allowed values per the subscribers_email_status_check DB constraint.
 *
 * `unsubscribed_at` is the send gate; DB trigger `subscribers_sync_email_unsubscribe_state`
 * keeps it aligned with `email_status` on insert/update (user opt-out + admin edits).
 */
/** CRM/manual creates: on the list in engine, not newsletter-confirmed. */
export const SUBSCRIBER_EMAIL_STATUS_DEFAULT = 'raw';

export const SUBSCRIBER_EMAIL_STATUSES: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'pending', label: 'Pending' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'unsubscribed', label: 'Unsubscribed' },
  { value: 'raw', label: 'Raw' },
  { value: 'invited', label: 'Invited' },
];

/** Read subscriber email_status with fallback during column rename rollout. */
export function subscriberEmailStatus(row: {
  email_status?: string | null;
  status?: string | null;
} | null | undefined): string {
  if (!row) return '';
  const v = row.email_status ?? row.status;
  return typeof v === 'string' ? v.trim() : '';
}
